import React from 'react';
import {
  Grid,
} from '@mui/material';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import RefinanceOverview from '../../../feature/account/RefinanceOverview';
import useStyles from '../styles';
import { LoanOverViewType, PrepayParams, UserAccountComponent } from '../../../types/account';
import { getLoan } from '../../../queries/account';
import AccountDataLoading from '../../../components/DataLoading';

export default function RefinanceView(props: UserAccountComponent) {
  const { token } = props;
  const { loanId } = useParams<PrepayParams>();
  const { loanData, loanDataLoading, loanDataError } = getLoan(token, true);
  const classes = useStyles();
  const history = useHistory();
  const [type, setType] = React.useState<'refinanceRP' | 'cashout'| undefined>(undefined);
  const location = useLocation().pathname.split('/').pop();

  React.useEffect(() => {
    if (loanData) {
      if (loanDataError) {
        history.push('/account');
      }
      const foundLoan = loanData.find(
        (data: LoanOverViewType) => data.loan.id === loanId,
      );
      if (foundLoan) {
        if (!location) {
          history.push('/account');
        }
        if (location === 'rate-period') {
          setType('refinanceRP');
        }
        if (location === 'cashout') {
          setType('cashout');
        }
      }
    }
  }, [loanData]);

  return (
    <Grid
      container
      style={{ height: '100%' }}
      className={classes.baseBackground}
    >
      {(loanDataLoading)
          && (
            <AccountDataLoading
              paddingTop="15%"
              firstText="Estamos consultando tus datos..."
            />
          )}
      {loanData && type && (
        <RefinanceOverview
          token={token}
          type={type}
          loanId={loanId}
        />
      )}
    </Grid>
  );
}
